export const AGENT_UNAVAILABLE_MESSAGE =
  'Vee is having trouble right now. Your message is saved and Vee will reply once it recovers.';
